<template>
	<article class="public-order-page">
		<!-- 合作商户信息 -->
		<publicBusinessInfo :businessImgUrl="businessInfo.LogoUrl == '' ? businessImgUrl : businessInfo.LogoUrl" :businessName="businessInfo.CompanyName"></publicBusinessInfo>

		<section :class="['inputs_wrap']">
			<div class="user-info-input" v-if="false">
				<span>
					<i class="iconfont icon-location2 red-text"></i>
					出发地
				</span>
				<input readonly="true" @click="selectStartAddress()" class="start-address" placeholder="请选择出发地址" type="text" :value="startAddress" />
			</div>

			<div class="user-info-input">
				<span>
					<i class="iconfont icon-location2 red-text"></i>
					到达行政区
				</span>
				<input readonly="true" @click="selectDistrict()" class="start-address" placeholder="请选择城(镇)区" type="text" :value="district" />
			</div>

			<div class="user-info-input">
				<span>
					<i class="iconfont icon-location2 primaryColor-text"></i>
					目的地址
				</span>
				<input class="end-address" placeholder="请填写目的地址" type="text" v-model="inputAddress" />
			</div>

			<div class="user-info-input">
				<span>
					<i class="iconfont icon-location2 primaryColor-text"></i>
					联系人
				</span>
				<input class="end-address" placeholder="请填写姓名或称呼" type="text" v-model="contact" />
			</div>

			<div class="user-info-input">
				<span>
					<i class="iconfont icon-location2 primaryColor-text"></i>
					联系电话
				</span>
				<input class="end-address" placeholder="请填写电话以便联系" type="text" v-model="mobile" />
			</div>

			<div class="user-info-input">
				<span>
					<i class="iconfont icon-lvke primaryColor-text"></i>
					乘车人数
				</span>
				<input readonly="true" class="end-address" placeholder="请选择乘车人数" type="text" :value="memberCount" @click="chooseMemberCount()" />
			</div>

			<div class="user-info-input">
				<span>
					<i class="iconfont icon-hanglixiang primaryColor-text"></i>
					行李件数
				</span>
				<input readonly="true" class="end-address" placeholder="请选择行李件数" type="text" :value="luggageCount" @click="chooseLuggageCount()" />
			</div>
		</section>

		<p class="notice reservation_service_notice red_color flex_wrap a_i_center" @click="showWarningTips">
			<i class="iconfont icon-gantanhao"></i>
			<span>旗妙出行约车须知</span>
		</p>

		<div class="btn_wrap big-btn">
			<button class="save_btn" @click="makeOrder()" :disabled="!(totalPrice > 0)">{{ totalPrice != 0 ? '一口价：' + totalPrice + '元' : '' }}确认下单</button>
		</div>

		<section class="btn_wrap">
			<img style="vertical-align: middle;text-align: center; width: 150px; height: 150px;" src="/../static/img/youtoqrcode.jpg" />
			<p class="text-center red-text">请先长按关注公众号以便接收订单消息推送</p>
		</section>

		<!--服务协议弹出层 Start  -->
		<transition :name="transitionName" mode="out-in">
			<article v-show="showMask" class="mask_wrap" @click.self="showWarningTips">
				<transition name="scale_up" mode="out-in">
					<section v-if="showMask" :class="['mask_container_wrap']">
						<div class="mask_article_wrap">
							<h3 class="article_title red_color">接送车服务须知</h3>
							<!-- <p class="p_title">一、注意事项</p> -->
							<p class="red-text">*当天12:30以前的班车接送，在乘车前一天下午17:00左右通知实际接送乘车时间</p>
							<p class="red-text">*当天12:30以后的班车接送，在乘车当天早上10:00左右通知实际接送乘车时间</p>

							<p class="p_title">一、预约接送服务需至少提前一天在[中山市旅游集散中心]公众号上提前购买。</p>
							<div style="text-align: center;">
								<img style="vertical-align: middle;text-align: center;" src="/../static/img/youtoqrcode.jpg" />
								<p class="text-center red-text">请先长按关注公众号以便接收订单消息推送</p>
							</div>
							<p class="p_title">
								二、请旅客收到接送时间后，提前到达接送地点，并保持电话畅通。若您所提供的电话号码长时间处于无人接听、忙音等状况而使我们不能及时联系到您，由此造成的损失，均由旅客本人负责。
							</p>
							<p class="p_title">
								三、由于旅客自身原因，未能准时到达预约地点的，且未提前联系客服0760-88880777说明原因的，逾时5分钟后视为自动放弃接送服务，接送费用照收，不作另外退还，非司机原因（如堵车、他人责任的交通事故等）造成旅客的延误或其他损失，我方不承担相应的责任。
							</p>
							<p class="p_title">四、服务车型为5座轿车，服务价格以我司移动端现行公示为准，旅客在我们的页面查看相关服务的价格。现行服务价格标准如下：</p>

							<div class="table xingli">
								<ul class="tr bg_th_orderinfo">
									<li class="th">起/止地</li>
									<li class="th">价格[{{ isGo ? '去程' : '返程' }}]</li>
									<!-- <li class="th">包车价格/车</li> -->
								</ul>
								<ul v-for="(item, key, index) in priceTable" :key="index" class="tr">
									<li class="td">{{ item.District }}</li>
									<li class="td">{{ item.singlePrice }}/人</li>
									<!-- <li class="td">{{ item.doublePrice }}元/车</li> -->
								</ul>
							</div>
							<p class="text-center red-text">2人8折、3人7折、4人6折。</p>
							<p class="text-center red-text">注：以上价格随时可能更新，具体以页面公示最新价格标准为准。</p>

							<p class="">A. 单人或2-3人购买接送服务，沿途拼车，同一订单同一地址视为1单接送，每车4位乘客为上限。</p>
							<p class="">B. 4人购买接送服务，同一订单同一地址视为包车接送.</p>
							<p class="p_title">五、行李件数：</p>
							<p class="">
								拼车每人可免费携带26寸以下行李1件(4人同一订单同一地址视为包车,行李总数不超4件)，超出行李（26寸以上按2件计算）按10元/件收取费用，若行李较多可在下单前电话咨询。
							</p>
							<p class="p_title">
								六、接送服务在未安排车辆和未通知接送时间前，旅客取消接送，不收取接送费；若已安排接送车辆并通知接送时的，由于旅客个人原因，需要取消接送服务的，视为自动放弃接送服务，不作另外退还。
							</p>
							<p class="p_title">
								七、旅客不得携带危险品或者其他法律、法规规定禁止或不适宜携带的物品搭乘车辆驾驶员的车辆，否则车辆驾驶员有权拒绝提供服务,并由旅客承担任何携带该等物品引起的后果和责任。
							</p>
							<p class="p_title">八、旅客不得在不乘坐车辆的情况下,委托驾驶员单独运送物品。</p>
							<p class="p_title">
								九、旅客不得在使用服务过程中进行违反平台规则的不文明的行为(包括吸烟、喝酒、吐痰、辱骂或殴打驾驶员) ,
								不得进行或要求车辆驾驶员进行违反相关交通规则或者其他法律法规的行为，因旅客违反禁止行为的原因导致有关部门行政处罚、人员受伤、发生交通事故、造成车辆损坏或其他损失的,旅客应向受损方进行赔偿
							</p>
							<p class="p_title">
								十、旅客应当具备完全民事行为能力(年满18周岁或年满16周岁、以自己的劳动收入为主要生活来源,且精神健康能完全辨认自己的行为) ,
								同时,旅客应当保证发布出行信息时是自愿的,且不存在意识不清楚、醉酒等情形。若旅客有意识不清楚、醉酒等情形的，陪同人员代为发布的出行需求信息视为旅客的行为;；在旅客醉酒或存在其他意识不清楚的情况下,应当由意识清楚的第三方陪同;；在旅客饮酒、醉酒或意识不清楚的情况下,给他人造成损失的,旅客本人应当就相应损失予以赔偿。
							</p>
						</div>
					</section>
				</transition>
			</article>
		</transition>
	</article>
</template>

<script>
import businessApi from '@/request/businessApi';
import appointApi from '@/request/appointApi';
import addressApi from '@/request/addressApi';
import salesApi from '@/request/salesApi';
import orderApi from '@/request/orderApi';
import paymentApi from '@/request/paymentApi';

import Header from './child-components/Header';
import Swiper from './child-components/Swiper';
import publicBusinessInfo from './child-components/publicBusinessInfo';
import InputInfo from './child-components/InputInfo';

import baseTool from '@/utils/baseFunction';

//引入vuex下mapState模块,该模块作用为方便调用state数据,语法糖
import { mapState } from 'vuex';
export default {
	name: 'AppointQuickMakeOrder',
	components: {
		'hq-header': Header,
		'public-order-input': InputInfo,
		Swiper,
		publicBusinessInfo
	},
	data() {
		return {
			name: '',
			transitionName: 'tanchu',
			businessInfo: {},
			businessImgUrl: '/../static/img/news.gif',
			businessName: '中山港客运码头',
			businessAddressList: [],
			qrcodeUrl: '../static/img/youtoqrcode.jpg',
			noLimit: false,
			inputAddress: '',
			isGo: false,
			district: '',
			memberCount: 1,
			luggageCount: 0,
			showMask: false,
			pickupPlaceList: [],
			selectedPickupPriceModel: null,
			pickupPriceList: [],
			priceTable: [],
			bookingDate: '',
			startAddress: '',
			mobile: '',
			contact: ''
		};
	},
	activated() {
		let that = this;
		//每次加载页面触发
		//通过dispatch调用ticket下actions异步函数中方法,最终改变state里面数据,
		// 第一个参数为方法路径,第二个参数为该方法的实参
		// this.computedAvableTime();
		this.tmpTimer = setInterval(() => {
			if (this.$store.state.user.OpenId && this.$store.state.user.OpenId.length > 0) {
				clearInterval(this.tmpTimer);
				addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes => {
					let result = sucRes;
					if (result.success && result.data.length > 0) {
						for (let i = 0; i < result.data.length; i++) {
							if (result.data[i].IsDefault) {
								this.$store.commit('ticket/setDefaultAddress', result.data[i]);
								this.inputAddress = result.data[i].Address;
								this.district = result.data[i].District;

								this.getPickupPriceList();
								break;
							}
						}
					}
				});

				if (this.$route.params.from && this.$route.params.from.length) {
					this.fromParams = this.$route.params.from;
					salesApi.firstBinding(this.fromParams, this.$store.state.user.OpenId).then(sucRes => {
						console.log(sucRes);
					});
				}
			}
		}, 500);

		if (this.$route.params.name && this.$route.params.name.length) {
			this.name = this.$route.params.name;
			//根据标识获取商户信息
			this.getBusinessInfo();
			//获取商户列表
			this.getBusinessAddressList();
		}

		// if (this.$route.params.back && this.$route.params.back.length) {
		// 	if (this.$route.params.back === 'back') {
		// 		this.isGo = false;
		// 		this.$store.commit('appoint/setData', {
		// 			isGo: this.isGo
		// 		});
		let tmpDate = new Date();
		tmpDate.setTime(tmpDate.getTime() + 20 * 60 * 1000);
		this.bookingDate = baseTool.dateFormat(tmpDate, 'yyyy-MM-dd HH:mm');
		// 	}
		// }
		// if (this.$route.params.limit && this.$route.params.limit.length) {
		// 	if (this.$route.params.limit === 'nolimit') {
		// 		this.noLimit = true;
		// 		let tmpDate = new Date();
		// 		tmpDate.setTime(tmpDate.getTime() + 10 * 60 * 1000);
		// 		this.setTime = baseTool.dateFormat(tmpDate, 'HH:mm');
		// 	}
		// }
		if (this.$route.params.from && this.$route.params.from.length) {
			this.fromParams = this.$route.params.from;
		}
	},
	methods: {
		getBusinessInfo() {
			//获取商户信息
			businessApi.getBusinessInfo(this.name).then(res => {
				if (res.success) {
					this.businessInfo = res.data;
					this.businessName = res.data.CompanyName;
					this.$store.commit('appoint/setData', { businessSign: this.name }); // new
				}
			});
		},
		getBusinessAddressList() {
			//获取商户地址列表
			businessApi.getBusinessAddressList(this.name).then(res => {
				// console.log(res);
				if (res.success) {
					this.businessAddressList = res.data;
					console.log(this.businessAddressList);
					this.businessAddressList.forEach(item => {
						if (item.IsDefault) {
							this.startAddress = item.MarkName;
							this.$store.commit('appoint/setData', {
								MarkName: item.MarkName, // new
								bookingEndAddr: item.Address,
								bookingEndPointLo: item.Longitude,
								bookingEndPointLa: item.Latitude
							});
							this.getPickupPriceList();
						}
					});
				}
			});
		},
		chooseLuggageCount() {
			let luggageNum = [];
			if (!luggageNum.length) {
				for (let i = 0; i <= 4; i++) {
					var luggage_item = {};
					luggage_item.label = ('' + i).length === 1 ? '' + i : '' + i;
					// luggage_item.label = ('' + i).length === 1 ? '0' + i : '' + i;
					luggage_item.value = i;
					luggageNum.push(luggage_item);
				}
			}
			this.$weui.picker(luggageNum, {
				onConfirm: result => {
					this.luggageCount = parseInt(result[0].label);
				}
			});
		},
		chooseMemberCount() {
			let memberNum = [];
			if (!memberNum.length) {
				for (let i = 1; i <= 4; i++) {
					var member_item = {};
					member_item.label = ('' + i).length === 1 ? '' + i : '' + i;
					// luggage_item.label = ('' + i).length === 1 ? '0' + i : '' + i;
					member_item.value = i;
					memberNum.push(member_item);
				}
			}
			this.$weui.picker(memberNum, {
				onConfirm: result => {
					this.memberCount = parseInt(result[0].label);
				}
			});
		},
		selectDistrict() {
			let that = this;
			let tmpArray = [];
			for (let i = 0; i < this.pickupPriceList.length; i++) {
				let tmp = {
					label: this.pickupPriceList[i].District,
					value: this.pickupPriceList[i].District
				};
				tmpArray.push(tmp);
			}
			this.$weui.picker(tmpArray, {
				onConfirm(result) {
					that.district = result[0].value;
					for (let i = 0; i < that.pickupPriceList.length; i++) {
						if (that.pickupPriceList[i].District === that.district) {
							that.selectedPickupPriceModel = that.pickupPriceList[i];
							break;
						}
					}
				}
			});
		},
		selectStartAddress() {
			//选择商户地址列表
			let addressList = [];
			let that = this;
			// console.log(this.businessAddressList);
			if (this.businessAddressList.length) {
				for (let i = 0; i < this.businessAddressList.length; i++) {
					let addressLiatTmp = {
						label: this.businessAddressList[i].MarkName,
						value: this.businessAddressList[i].MarkName
					};
					addressList.push(addressLiatTmp);
				}
			}
			this.$weui.picker(addressList, {
				onConfirm: result => {
					this.startAddress = result[0].value;
					let tmp = null;
					this.businessAddressList.forEach(item => {
						if (item.MarkName == this.startAddress) {
							tmp = item;
						}
					});
					console.log(tmp);
					this.$store.commit('appoint/setData', {
						MarkName: tmp.MarkName, // new
						bookingEndAddr: tmp.Address,
						bookingEndPointLo: tmp.Longitude,
						bookingEndPointLa: tmp.Latitude
					});
					this.getPickupPriceList();
				}
			});
		},
		getPickupPriceList() {
			this.pickupPriceList = [];
			this.$Spin.show();
			businessApi.getBusinessPickupPriceList(this.name, this.$store.state.appoint.MarkName).then(sucRes => {
				this.$Spin.hide();
				if (sucRes.success && sucRes.data.length > 0) {
					this.pickupPriceList = sucRes.data;
					for (let i = 0; i < this.pickupPriceList.length; i++) {
						if (this.pickupPriceList[i].District === this.DefaultAddress.District) {
							this.selectedPickupPriceModel = this.pickupPriceList[i];
							break;
						}
					}
					this.makePriceTable();
				} else {
					this.$Message.warning('没有该点的接送报价！');
				}
			});
		},
		// 生成价格表
		makePriceTable() {
			let tmpPriceArr = [];
			this.priceTable = [];
			for (let i = 0; i < this.pickupPriceList.length; i++) {
				if (this.pickupPriceList[i].Status) {
					if (this.isGo) {
						let tmpPrice = this.pickupPriceList[i].Price;
						if (tmpPriceArr.indexOf(tmpPrice) == -1) tmpPriceArr.push(tmpPrice);
					} else {
						let tmpPrice = this.pickupPriceList[i].BackPrice;
						if (tmpPriceArr.indexOf(tmpPrice) == -1) tmpPriceArr.push(tmpPrice);
					}
				}
			} // 生成价格数组
			tmpPriceArr.sort((val1, val2) => {
				return val1 - val2;
			});
			for (let i = 0; i < tmpPriceArr.length; i++) {
				let tmpDistrictStr = '';
				for (let j = 0; j < this.pickupPriceList.length; j++) {
					if (this.isGo) {
						if (this.pickupPriceList[j].Price == tmpPriceArr[i]) tmpDistrictStr += this.pickupPriceList[j].District + '、';
					} else {
						if (this.pickupPriceList[j].BackPrice == tmpPriceArr[i]) tmpDistrictStr += this.pickupPriceList[j].District + '、';
					}
				}
				tmpDistrictStr = tmpDistrictStr.substring(0, tmpDistrictStr.length - 1);
				let priceComputedDescription = '';
				priceComputedDescription += Math.round(tmpPriceArr[i]) + '/1人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 2 * 0.8) + '/2人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 3 * 0.7) + '/3人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 4 * 0.6) + '/4人';
				var tmpObj = { District: tmpDistrictStr, singlePrice: tmpPriceArr[i], doublePrice: tmpPriceArr[i] * 2, priceComputedDescription: priceComputedDescription };
				this.priceTable.push(tmpObj);
			}
		},
		showWarningTips() {
			this.showMask = !this.showMask;
		},
		makeOrder() {
			if (this.totalPrice > 0 && this.district != '' && this.mobile != '') {
				if (this.inputAddress == '') this.inputAddress = this.district;
				if (this.contact == '') this.contact = '乘客';

				appointApi.convertAddressToLocation(this.cityName, this.inputAddress).then(sucRes => {
					if (sucRes.status == '1' && sucRes.info == 'OK' && sucRes.pois && sucRes.pois.length > 0) {
						orderApi
							.createBusinessAppointOrder(
								this.$store.state.user.OpenId,
								this.contact,
								this.name,
								this.MarkName,
								this.memberCount,
								this.luggageCount,
								this.bookingDate,
								this.serviceType,
								this.mobile,
								this.district,
								this.inputAddress,
								'',
								'',
								this.cityName,
								this.totalPrice,
								'',
								0,
								'nolimit',
								this.Location,
								this.fromParams
							)
							.then(sucRes => {
								if (sucRes.success) {
									this.$Message.success(sucRes.message);
									this.paymentOrder(sucRes.data.ID);
								} else {
									this.$Message.error(sucRes.message);
								}
							});
					} else {
						alert(`[${this.inputAddress}]不能解析成对应座标，请重新输入地址并尽可能缩小范围。`);
					}
				});
			} else {
				alert('请选择到达区域与填写联系电话，以便司机联系。');
			}
		},
		paymentOrder(orderId) {
			var that = this;
			// this.$Spin.show();
			wx.miniProgram.getEnv(function(res) {
				if (res.miniprogram) {
					// true代表在小程序里
					that.$Spin.hide();
					var url = `../webpayprocess/webpayprocess?ordertype=2&id=${orderId}&businessid=2`;
					wx.miniProgram.navigateTo({
						url: url
					});
				} else {
					//false代表在公众号里
					paymentApi.getWeChatPayParams(that.$store.state.user.OpenId, orderId, 2, 2).then(sucRes => {
						if (sucRes.success) {
							wx.chooseWXPay({
								timestamp: sucRes.data.timeStamp,
								nonceStr: sucRes.data.nonceStr,
								package: sucRes.data.package,
								signType: sucRes.data.signType,
								paySign: sucRes.data.paySign,
								success: res => {
									that.$Message.success('支付成功！');
									that.$router.replace({
										name: 'MainIndexPage',
										params: {
											page: 'myorder'
										}
									});
									// window.location.href = '//www.callmefix.net/wechat/orderlst/';
								},
								fail: fail => {
									that.$Message.warning('支付失败！');
									that.$router.replace({
										name: 'MainIndexPage',
										params: {
											page: 'myorder'
										}
									});
								}
							});
						} else {
							that.$Message.error(sucRes.message);
						}
						// that.$Spin.hide();
					});
				}
			});
		}
	},
	//使用mapState模块映射数据
	computed: mapState({
		DefaultAddress: state => state.ticket.DefaultAddress,
		serviceType: state => state.appoint.serviceType,
		// businessName: state => state.appoint.businessSign,
		MarkName: state => state.appoint.MarkName,
		cityName: state => state.appoint.CityName,
		Location: state => state.user.Location,
		totalPrice() {
			var price = 0;
			if (this.selectedPickupPriceModel) {
				// var moreCar = parseInt(this.memberCount / 4); // 加车辆数
				// var countMember = this.memberCount % 4; // 全部人数除4取余，得出剩余人数。
				let basePrice = 0;
				if (this.isGo) {
					basePrice = this.memberCount * (this.selectedPickupPriceModel.Price + this.selectedPickupPriceModel.OTPrice);
				} else {
					basePrice = this.memberCount * (this.selectedPickupPriceModel.BackPrice + this.selectedPickupPriceModel.BackOTPrice);
				}
				// price += countMember >= 2? (this.selectedPickupPriceModel.Price + this.selectedPickupPriceModel.OTPrice) * 2: (this.selectedPickupPriceModel.Price + this.selectedPickupPriceModel.OTPrice) * countMember;
				switch (this.memberCount) {
					case 1:
						price += basePrice;
						break;
					case 2:
						price += Math.round(basePrice * 0.8);
						break;
					case 3:
						price += Math.round(basePrice * 0.7);
						break;
					case 4:
						price += Math.round(basePrice * 0.6);
						break;
				}
				// price += moreCar > 0 ? (this.selectedPickupPriceModel.Price + this.selectedPickupPriceModel.OTPrice) * 2 * moreCar : 0;
				if (this.luggageCount > this.memberCount) {
					// if (this.memberCount == 1) {
					price += 10 * (this.luggageCount - this.memberCount);
					// }
				}
				return price;
			}
		}
		// bookingDate: state => state.appoint.bookingDate
	})
};
</script>

<style scoped lang="less">
@import '../style/public';

.public-order-page {
	justify-content: initial;
	.business-info {
		background-color: #fff;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
	}
	.notice {
		.blockPadding(0, 0.5rem);
		.red-text;
	}
}

.inputs_wrap {
	width: 90%;
	margin: 0.5rem auto;
	background-color: #fff;
	position: relative;
	.shadow(10px, 0, 0, rgba(0, 0, 0, 0.4));
	.radius;
	.blockPadding(0, 0.4rem);

	.user-info-input {
		.flex_wrap(initial, center);
		.blockPadding(0.3rem, 0);
		padding-left: 0.2rem;
		&:first-child {
			margin-right: 1rem;
		}
		& .iconfont {
			margin-right: 5px;
			font-size: 0.4rem;
		}
		& > span {
			padding-right: 10px;
		}

		& > span:first-child {
			// .border-R;
			.flex_items(auto, 0, 0);
			text-align: left;
		}

		& > input,
		& > span:last-child {
			border: none;
			background-color: transparent;
			.blockPadding(0, 10px);
		}

		// &>span:last-child{}
	}
	.exchange {
		position: absolute;
		.wh(1.2rem, 1.2rem);
		.flex_wrap(center, center);
		top: 0.65rem;
		right: 0.6rem;
	}

	.text-center {
		& > button {
			margin: 0 auto;
		}
	}

	& > .user-info-input:nth-last-child(n + 2) {
		.border-B(1px, solid);
	}
}

.btn_wrap {
	text-align: center;
	.margin-Tb(0.3rem, 0);
}
.big-btn {
	button {
		width: 90%;
		.btn();
		.radius;
		.primarybtnColor;
		.shadow(8px);
	}
}

.exchange-btn {
	position: relative;
	background-color: transparent;
	width: 0.7rem;
	height: 0.7rem;
	.shadow(5px);

	& > i {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-45%, -50%);
		font-size: 0.4rem;
		color: #fff;
		text-shadow: 0 0 5px #E77618;
		z-index: 2;
	}

	text-align: center;
	// .flex_wrap(center,center);
	// background-color: #E7761852;
	.radius(50%);
	.btn;

	&:after {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #E77618;
		opacity: 0.8;
		z-index: 1;
		.radius(50%);
	}
}

#panel {
	position: fixed;
	background-color: white;
	max-height: 90%;
	overflow-y: auto;
	top: 10px;
	right: 10px;
	width: 280px;
}
#panel .amap-call {
	background-color: #009cf9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}
#panel .amap-lib-driving {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow: hidden;
}
#allMap {
	width: 100%;
	height: 50%;
	max-height: 50%;
}

/*iconfont*/
.mask_container_mapwrap {
	width: 100%;
	height: 90%;
	overflow: scroll;
	margin: auto;
	border-radius: 10px;
	background-color: #fff;
	transform: scale(0);
	transition: all 0.4s;
	padding: 3%;
	position: absolute;
}

.j_c_center {
	justify-content: center;
}
.a_i_center {
	align-items: center;
}
.flex_wrap {
	display: flex !important;
}
.mask_show {
	z-index: 100;
	opacity: 1;
}
.mask_show > .scale_up {
	transform: scale(1);
}
.btn_wrap {
	width: 100%;
	text-align: center;
	margin: 1em 0;
}
.btn {
	padding: 0 3%;
	text-indent: 5px;
	letter-spacing: 5px;
	font: 600 0.4rem/1rem '微软雅黑';
	border-radius: 5px;
	border: 1px solid #888;
	box-shadow: 0 0 5px #586c94;
	margin: 5px auto;
}
.article_title {
	font-size: 0.5rem;
	text-align: center;
	line-height: 6vh;
	font-weight: 600;
}
.red_color {
	color: #e22222;
}
</style>



// WEBPACK FOOTER //
// src/components/AppointQuickMakeOrder.vue